document.addEventListener('DOMContentLoaded', function () {
    // Handle complementary product quick add buttons
    document.addEventListener('click', function (event) {
        if (event.target.closest('.complementary-quick-add')) {
            event.preventDefault();
            addComplementaryProductToCart(event.target.closest('.complementary-quick-add'));
        }
    });

    function addComplementaryProductToCart(button) {
        const variantId = button.dataset.variantId;
        const productTitle = button.dataset.productTitle;

        if (!variantId) {
            console.error('No variant ID found for complementary product');
            return;
        }

        // Check if button is already disabled
        if (button.getAttribute('aria-disabled') === 'true') return;

        // Add loading state using theme's standard approach
        const buttonText = button.querySelector('.complementary-add-btn-text');
        const buttonLoading = button.querySelector('.complementary-add-btn-loading');

        button.setAttribute('aria-disabled', true);
        button.classList.add('loading');

        if (buttonText && buttonLoading) {
            buttonText.style.display = 'none';
            buttonLoading.style.display = 'inline-flex';
        }

        // Get cart system (same as theme's product-form.js)
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        // Use theme's fetchConfig function if available, otherwise create similar config
        const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : {
            method: 'POST',
            headers: {
                'Accept': 'application/javascript',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };

        // Remove Content-Type to let browser set it for FormData
        if (config.headers['Content-Type']) {
            delete config.headers['Content-Type'];
        }

        // Prepare form data (same structure as theme)
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        // Add sections for cart update (same as theme)
        if (cart && typeof cart.getSectionsToRender === 'function') {
            formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
            cart.setActiveElement(button);
        }

        config.body = formData;

        // Make request using same approach as theme's product-form.js
        fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
                // Handle errors same way as theme
                if (response.status) {
                    console.error('Error adding to cart:', response.description);
                    handleErrorMessage(response.description);
                    return;
                } else if (!cart) {
                    // Fallback to cart page if no cart drawer/notification
                    window.location = routes.cart_url;
                    return;
                }

                // Success - update cart and open drawer (same as theme)
                if (cart && typeof cart.renderContents === 'function') {
                    cart.renderContents(response);
                }
            })
            .catch((e) => {
                console.error('Fetch error:', e);
            })
            .finally(() => {
                // Reset button state (same as theme)
                button.classList.remove('loading');
                button.removeAttribute('aria-disabled');

                if (buttonText && buttonLoading) {
                    buttonText.style.display = 'inline';
                    buttonLoading.style.display = 'none';
                }

                // Remove empty class from cart if needed (same as theme)
                if (cart && cart.classList.contains('is-empty')) {
                    cart.classList.remove('is-empty');
                }
            });
    }

    function handleErrorMessage(errorMessage) {
        // Simple error logging - let the theme handle UI errors
        console.error('Complementary product add error:', errorMessage);
    }
});  